import { CompassIcon, TypeIcon, PuzzleIcon, TargetIcon } from 'lucide-react';

export const painPoints = [
  {
    icon: CompassIcon,
    title: 'You don’t know where to start',
    desc: 'The blank page slows you down. This system gives you structured prompts to help organize incident documentation, training materials, and station records.',
  },
  {
    icon: TypeIcon,
    title: 'You spend too much time on repetitive writing',
    desc: 'Start with a clear framework instead of writing every document from scratch. Adapt the output to your department’s procedures and requirements.',
  },
  {
    icon: PuzzleIcon,
    title: 'You’re unsure how to use AI professionally',
    desc: 'Generic requests can produce generic answers. Purpose-built prompts help you provide context, specify the desired format, and review the result more efficiently.',
  },
  {
    icon: TargetIcon,
    title: 'You want more time for the work that matters',
    desc: 'Documentation and administrative tasks are part of the job, but a more organized workflow can help you approach them with less friction.',
  },
];
